__turbopack_context__.v({
  "loading": "loader-module__KH0AsW__loading",
  "loadingContainer": "loader-module__KH0AsW__loadingContainer",
  "loadingText": "loader-module__KH0AsW__loadingText",
  "loadingWrapper": "loader-module__KH0AsW__loadingWrapper",
});
